import { asyncActionCreators } from '../../utils/actions';

export const queryJourneysForRides = asyncActionCreators('Rides/QUERY_JOURNEYS');
export const getLocations = asyncActionCreators('Rides/GET_LOCATIONS');
export const getEventsGeoData = asyncActionCreators('Rides/GET_EVENTS_GEO_DATA');
export const checkJourneysEverExist = asyncActionCreators('Rides/CHECK_JOURNEYS_EVER_EXIST');
export const checkJourneysForMonthExist = asyncActionCreators('Rides/CHECK_JOURNEYS_FOR_MONTH_EXIST');
export const appealEventPenalty = asyncActionCreators('Rides/APPEAL_EVENT_PENALTY');



// WEBPACK FOOTER //
// ./src/sagas/rides/actions.js